import { SpeakerClient, SpeakerConfig } from '../clients/SpeakerClient';
import ClientCallback from '../lib/clientCallback';
import { live } from '../clients/proto';
import { CallbackType } from '../const/common';

export interface SpeechRecognizerConfig {
  clientCallback?: ClientCallback;
  srcLang: string;
  provider?: string;
  terminalInfo: live.ITerminalInfo;
}

export default class SpeechRecognizer {
  config: SpeechRecognizerConfig;
  speakerClient: SpeakerClient;
  clientCallback: ClientCallback;

  constructor(config: SpeechRecognizerConfig) {
    this.config = config;
  }

  start() {
    if (this.speakerClient) {
      this.speakerClient.continue();
    } else {
      const { srcLang, provider, terminalInfo, clientCallback } = this.config;
      const speakerConfig: SpeakerConfig = {
        srcLang,
        provider,
      };
      this.speakerClient = new SpeakerClient(
        speakerConfig,
        terminalInfo,
        this.handleClientCallback
      );
      if (clientCallback) {
        this.clientCallback = clientCallback;
      }
    }
  }

  stop() {
    this.speakerClient && this.speakerClient.stop();
  }

  sendVoiceBuffer(buffer: ArrayBuffer, timestamp: number) {
    this.speakerClient && this.speakerClient.sendVoiceBuffer(buffer, timestamp);
  }

  restart(speechRecognizerConfig?: SpeechRecognizerConfig) {
    if (this.speakerClient) {
      if (speechRecognizerConfig) {
        const speakerConfig: SpeakerConfig = {
          srcLang: speechRecognizerConfig.srcLang,
          provider: speechRecognizerConfig.provider,
        };
        this.speakerClient.resetConfig(speakerConfig);
      }
      this.speakerClient.restartWs();
    }
  }

  setClientCallback(clientCallback: ClientCallback) {
    this.clientCallback = clientCallback;
  }

  handleClientCallback = (cbType: CallbackType, payload?: any) => {
    switch (cbType) {
      case CallbackType.OPEN: {
        if (this.clientCallback) {
          this.clientCallback.onOpenCallback();
        }
        break;
      }
      case CallbackType.CLOSE: {
        if (this.clientCallback) {
          const { code, message, extra } = payload;
          this.clientCallback.onCloseCallback(code, message, extra);
        }
        break;
      }
      case CallbackType.FAIL: {
        if (this.clientCallback) {
          const { code, message } = payload;
          this.clientCallback.onFailCallback(code, message);
        }
        break;
      }
      default: {
        break;
      }
    }
  };
}
